function NightAuditTaxReport() {
    return (
      <>
        <div className="font-bold text-lg mb-16">NightAuditTaxReport</div>
      </>
    );
  }
  
  export default NightAuditTaxReport;